<template>
  <div class="athletes_photo" style="width:100%;margin-top: 30px;">
    <header>
      <h1>{{details.matchName}}</h1>
      <h2>{{userInfo.schoolName}}大学生参赛运动员</h2>
    </header>
    <template v-if="getShowNum > 0">
      <template v-for="item in getShowNum">
        <div :key="item" :style="{pageBreakAfter:item % 3 == 0?'always':''}" :class="[item !== 1 && item % 3 === 1?'margin_top':'']">
          <div class="top" style="width:100%;display:flex">
            <div
              :class="[(index + 1) == 10?'border_right':'',index == 0?'border_left':'',item % 4 == 0 || item == 1?'border_top':'']"
              :style="{borderRight:(index+1) == 10 ?'none':'1px solid #999'}"
              style="width:10%;box-sizing:border-box"
              v-for="(temp,index) in details.athleteList.slice((item - 1) * 10,item * 10)"
              :key="index + '_' + item"
            >
              <div style="display:flex;justify-content:center;align-items:center;">
                <section style="padding:10px;">
                  <img :src="temp.headImage" style="width:100px;height:120px;" alt />
                </section>
              </div>
            </div>
          </div>
          <div class="bottom" style="width:100%;display:flex">
            <div
              :style="{borderRight:(index+1) == 10 ?'none':'1px solid #999',borderBottom:item === getShowNum?'none':'1px solid #999'}"
              style="width:10%;display:flex;flex-direction:column;justify-content:center;align-items:center;border:1px solid #999;border-left:none;padding:10px;box-sizing:border-box"
              v-for="(temp,index) in details.athleteList.slice((item - 1) * 10,item * 10)"
              :key="index + '-' + item"
              :class="[(index + 1) == 10?'border_right':'',index == 0?'border_left':'',item === getShowNum?'border_bottom':'','athlete_infos']"
            >
              <p class='athlete_name' style="margin:0 0 10px;font-size:16px;color:#444;display:flex;padding:0;">
                <span style="max-width:140px;">{{temp.athleteName}}</span>
              </p>
              <p
                class='athlete_regist_number'
                style="word-wrap: break-word;word-break: break-all;text-align: center;font-size:14px;padding:0;margin:0"
              >{{temp.registerNumber}}</p>
            </div>
          </div>
        </div>
      </template>
    </template>
    <template v-else>
        <div style="width:100%;height:200px;display:flex;align-items:center;justify-content:center;font-size:24px">暂无数据</div>
    </template>
  </div>
</template>
<script>
import { getSession } from "@/utils/storage.js";
export default {
  props: ["details"],
  data() {
    return {
      userInfo: JSON.parse(getSession("userInfo")) || "",
      athleteList: []
    };
  },
  computed: {
    getShowNum() {
      let num = 0;
      if (
        this.details.athleteList &&
        this.details.athleteList.length < 10 &&
        this.details.athleteList.length > 0
      ) {
        num = 1;
      } else if (
        this.details.athleteList &&
        this.details.athleteList.length >= 10
      ) {
        let length = this.details.athleteList.length;
        if (length / 10 > parseInt(length / 10)) {
          num = parseInt(length / 10) + 1;
        } else {
          num = length / 10;
        }
      }
      
      return num;
    }
  },
  mounted() {}
};
</script>
<style lang="less" scoped>
.athletes_photo {
  width: 100% !important;
  border:1px solid #999;
  > header {
    text-align: center;
    padding: 44px 0;
    color: #444;
    font-weight: 600;
    border-bottom: 1px solid #999;
    > h1 {
      font-size: 24px;
      margin-bottom: 14px;
    }
    > h2 {
      font-size: 22px;
    }
  }
}
</style>